import React from "react";
import { useNavigate } from "react-router-dom";
import { encryptAES } from "../../Common/Axios/encrypt";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import feature from "../../Assets/imgNewUI/featured.svg";
const CommonWebOffer = ({
  index,
  offer,
  matchingCoupon,
  page,
  handleDealCouponWeb = () => {},
  isFeature
}) => {
  const navigate = useNavigate();
  const translation = getTranslation();
  const handleClaim = (dealData) => {
    navigate(`/Offers?did=${encryptAES(String(dealData?.id))}`);
    // handleDealCouponWeb(dealData);
    if (typeof handleDealCouponWeb === "function") {
      handleDealCouponWeb(dealData);
    }
  };
  return (
    <div
      key={index}
      className="w-64 flex-shrink-0 top-card rounded-lg overflow-hidden mt-2 flex flex-col"
      onClick={() => handleClaim(offer)}
    >
      <div className="relative">
        {isFeature ? (
        <>
          <div>
            <img className="featured_tag_web" src={feature} alt="feature" />
          </div>
        </>
      ) : (
        ""
      )}
        <img
          src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${offer?.webImage}`}
          alt={offer?.name}
          title={offer?.name}
          data-skuName={matchingCoupon?.title}
          className="p-img cursor-pointer"
        />
        {matchingCoupon?.discountText && (
          <span className="absolute top-0 left-0 discount px-3 py-1">
            {matchingCoupon?.discountText}
          </span>
        )}
      </div>
      <div className="flex flex-col flex-grow p-2">
        <h3 className="top-title  mt-2 mb-3">
          {offer?.name} {page ? <i className="fa fa-angle-right pl-2"></i> : ""}
        </h3>
        <span className="top-des mt-1 mb-3" title={matchingCoupon?.title}>
          {matchingCoupon?.title.length > 55
            ? matchingCoupon?.title?.substring(0, 55) + "..."
            : matchingCoupon?.title}
        </span>
        <button
          className="web-claim py-2 w-full mt-auto"
          onClick={(e) => {
            e.stopPropagation();
            handleClaim(offer);
          }}
        >
          {translation?.claimNow}
        </button>
      </div>
    </div>
  );
};

export default CommonWebOffer;
